import { render, staticRenderFns } from "./PesananSukses.vue?vue&type=template&id=6b93010d&"
import script from "./PesananSukses.vue?vue&type=script&lang=js&"
export * from "./PesananSukses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports